import { BACKEND_URL } from '@src/config/apollo';

// The PDF of a submitted report form - generic, or a client's own layout (Ward, RelyOn
// VPI / Alarm, PSG): wfc-server draws it (GET /reports/form/:jobId/pdf, routes/
// formReport.route.ts), signed in with the web session cookie. Replaces printing the
// report pages through wfc-automation's headless Chrome.
//   jobId       the duty / mobile service the report belongs to
//   checkCallId the check call's own report, on a duty with several (optional)
//   templateId  only used when the report itself doesn't record its template
export const downloadReportPdf = async ({ jobId, checkCallId, templateId, filename = 'report' }) => {
    const qs = new URLSearchParams();
    if (checkCallId) qs.set('checkCallId', checkCallId);
    if (templateId) qs.set('templateId', templateId);
    const res = await fetch(`${BACKEND_URL}/reports/form/${jobId}/pdf?${qs}`, { credentials: 'include' });
    if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.message || `Request failed (${res.status})`);
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${String(filename).replace(/[^\w\- ]+/g, '').trim() || 'report'}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
};
